import { dataMember, required, typedArray } from 'santee-dcts';
import { EQueryInfo } from './e-query-info';
import { EQuerySubmittedResponse } from './e-query-submitted-response';
import { EQueryAttachment } from './e-query-attachment';
import { EQueryCCQuestion } from '../../admin/e-query/models/e-query-c-c-question';
import { EQueryAccessionInfo } from '../../admin/shared/e-query-accession-info';
import {ExternalEQueryAccessionInfo} from '../accession-info/external-e-query-accession-info';

export class EQueryDetails {
    @dataMember()
    @required()
    public eQueryData: EQueryInfo;

    @dataMember()
    @required()
    public accessionData: ExternalEQueryAccessionInfo;

    @dataMember()
    @required()
    @typedArray(EQueryAttachment)
    public attachments: EQueryAttachment[];

    @dataMember()
    @required()
    @typedArray(EQueryCCQuestion)
    public questions: EQueryCCQuestion[];
    
    @dataMember()
    @required()
    @typedArray(EQuerySubmittedResponse)
    public responseDetails: EQuerySubmittedResponse[];
}
